module.exports = __webpack_public_path__ + "assets/media/cosmetic.a0b6888f.jpg";